import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {ApiServiceService} from '../api-service.service';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class LenderDashboardLinkProvider {
    private http: HttpClient;
    private apiService: ApiServiceService;
    private storageService: StorageService;

    constructor(http: HttpClient, apiService: ApiServiceService, storageService: StorageService) {
        this.http = http;
        this.apiService = apiService;
        this.storageService = storageService;
    }

    async getDashboardLink(): Promise<string> {
        const result = await this.http.post<any>(this.apiService.baseURL() + 'getLenderInfoDetails',
            {
                token: this.storageService.getItem(Keys.TOKEN),
                lender_id: this.storageService.getItem(Keys.LENDER_ID),
                profile_id: this.storageService.getItem(Keys.PROFILE_ID)
            }).pipe(map(response => response))
            .toPromise();

        if (result.status === 'success') {
            if (result.lender_info.lender_application_status !== 'verified' && result.lender_info.lender_application_status !== 'invested') {
                return '/lenderinitial';
            } else {
                return '/investordashboard';
            }
        }
    }
}
